import '../../node_modules/weui'
import CView from './c-view'
import CPage from './c-page'
import CLoading from './c-loading'
import CContent from './c-content'
import CFooter from './c-footer'
import CTab from './c-tab'
import CImages from './c-images'
import CButton from './c-button'
import CButtonRecharge from './c-button/recharge'
import CPanel from './c-panel'
import CPanelContainer from './c-panel/container'
import CPanelTitle from './c-panel/title'
import CTitleLine from './c-title-line'
// import CSwipe from './c-swipe'
// import CSwipeFullpage from './c-swipe-fullpage'
import CThum from './c-thum'
import CCellContainer from './c-cell/container'
import CCell from './c-cell'
import CCellTitle from './c-cell/title'
import CNumberInput from './c-number-input'
import CForm from './c-form'
import CCounter from './c-counter'
import CNavbar from './c-navbar'
import CMsg from './c-msg'
import CActionSheet from './c-action-sheet'
import CToast from './c-toast'
import CGallery from './c-gallery/index.vue'
import {gallery} from './c-gallery/index.js'
import CUpload from './c-upload'

const components = [
  CView,
  CPage,
  CLoading,
  CContent,
  CFooter,
  CTab,
  CImages,
  CButton,
  CButtonRecharge,
  CPanelContainer,
  CPanelTitle,
  CPanel,
  // CSwipe,
  // CSwipeFullpage,
  CThum,
  CCellContainer,
  CCell,
  CCellTitle,
  CNumberInput,
  CTitleLine,
  CForm,
  CCounter,
  CNavbar,
  CMsg,
  CActionSheet,
  CGallery,
  CUpload
]
const install = function (Vue, opts = {}) {
  if (install.installed) return
  components.map(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$toast = CToast
  Vue.prototype.$gallery = gallery
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  install,
  CView,
  CPage,
  CLoading,
  CContent,
  CFooter,
  CTab,
  CImages,
  CButton,
  CButtonRecharge,
  CPanelContainer,
  CPanelTitle,
  CPanel,
  // CSwipe,
  // CSwipeFullpage,
  CThum,
  CCellContainer,
  CCell,
  CNumberInput,
  CTitleLine,
  CForm,
  CCounter,
  CNavbar,
  CMsg,
  CActionSheet,
  CGallery,
  gallery,
  CUpload
}



// WEBPACK FOOTER //
// ./src/public-lib/vue-components/src/components/index.js